
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<BannerToast>({})
export default class BannerToast extends Vue {
	@Prop({ type: Object, default: {} }) bannerToastInfo: any;
}
